// extracted by mini-css-extract-plugin
export var attachButton = "_c6-8";
export var sendButton = "_c6-2";
export var sendDisabled = "_c6-4";
export var sendEnabled = "_c6-3";
export var sendIcon = "_c6-6";
export var sendIconDisabled = "_c6-7";
export var sendStreaming = "_c6-5";
export var textarea = "_c6-1";
export var wrapper = "_c6-0";